<template>
  <page-outline :title="$t('acceptance.add_rule')">
    <template slot="pageContent">
      <b-container>
        <back-button class="mb-4"></back-button>
        <b-row>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.company_admin_state')">
              <select class="form-control" id="sel2" readonly v-model="comp_state">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['comp_state']" :key="status.code" :value="status.code">
                  {{  getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.establish_admin_state')">
              <select class="form-control" id="sel2" readonly v-model="etab_state">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['etab_state']" :key="status.code" :value="status.code">
                  {{ getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.act_autorization')">
              <select class="form-control" id="sel2" readonly v-model="activity">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['activity']" :key="status.code" :value="status.code">
                  {{  getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.legal_process')">
              <select class="form-control" id="sel2" readonly v-model="legal_process">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['legal_process']" :key="status.code" :value="status.code">
                  {{ status.label }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.vat_nb_validity')">
              <select class="form-control" id="sel2" readonly v-model="tva">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['tva']" :key="status.code" :value="status.code">
                  {{  getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.is_in_registry')">
              <select class="form-control" id="sel2" readonly v-model="inscription">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['inscription']" :key="status.code" :value="status.code">
                  {{  getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.company_stability')">
              <select class="form-control" id="sel2" readonly v-model="stability">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['stability']" :key="status.code" :value="status.code">
                  {{ getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.available_status')">
              <select class="form-control" id="sel2" readonly v-model="status">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option v-for="status in supplierCodeList['status']" :key="status.code" :value="status.code">
                  {{  getLabel(status.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('Acceptance')">
              <select class="form-control" id="sel2" readonly v-model="score">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option value="1">{{ $t('acceptance.ok') }}</option>
                <option value="0">{{ $t('acceptance.ko') }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <form-write-group-label-input isMandatory
            :inputType="'listeSelect'"
            :inputLabel="$t('acceptance.status')">
              <select class="form-control" id="sel2" readonly v-model="final_status">
                <option value="">{{ $t('acceptance.select_stat') }}</option>
                <option value="1">{{ $t('acceptance.ok') }}</option>
                <option value="3">{{ $t('acceptance.warn') }}</option>
                <option value="4">{{ $t('acceptance.ko') }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-col cols="2" offset="10" class="form-group mt-3">
          <b-button variant="primary"
            @click="saveException()">
            {{ $t('common.sve') }}
          </b-button>
        </b-col>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'
import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'
import supplierCodeList from '@/data/suppliercode.json'

export default {
  name: 'AddNote',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  props: {
  },
  data () {
    return {
      comp_state: '',
      etab_state: '',
      activity: '',
      legal_process: '',
      tva: '',
      inscription: '',
      status: '',
      stability: '',
      final_status: '',
      id: '',
      score: '',
      supplierCodeList: supplierCodeList
    }
  },
  created () {
    this.siren = this.$engine.services.suppliers.selectedSupplier.Siren
  },
  methods: {
    getLabel (val) {
      switch (val) {
        case 'valide':
          return this.$t('acceptance.ok')
          break;
        case 'avertissement':
          return this.$t('acceptance.warn')
          break;
        case 'invalide':
          return this.$t('acceptance.ko')
          break;
        default:
        return '-'
        break;
      }
    },
    getCode (tab, value) {
      var foundLabel = ''
      this.supplierCodeList[tab].map(supplierCode => {
        if (value === supplierCode.label) {
          foundLabel = supplierCode.code
        }
      })
      if (foundLabel === '') {
        foundLabel = value
      }
      return foundLabel
    },
    saveException () {
      let that = this
      that.$engine.services.suppliers.createKYCVal(
        this.comp_state,
        this.etab_state,
        this.activity,
        this.legal_process,
        this.tva,
        this.inscription,
        this.status,
        this.stability,
        this.final_status,
        this.score
      ).then(resp => {
        that.$f7.modal({
          title: this.$i18n.t('acceptance.added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                loadPage(that, {url: '/kycexceptions/'})
              }
            }
          ]
        })
      })
      .catch(e => {
        errorMessageAlert(e, this, this.$i18n)
        let that = this
        that.$f7.modal({
          title: this.$i18n.t('acceptance.error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    }
  }
}

</script>
